import { useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { usePageView } from 'src/hooks/use-page-view';
import { OverviewMultis } from 'src/sections/overview-multis';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import { gotoListPage } from 'src/utils/navigation-utils';
import PageSection from 'src/layouts/page-section';
import { OverviewSingle } from 'src/sections/overview-single';
import useToast from 'src/utils/toast-utils';

const Page = ({ fuels, repairs }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const { toastMessage } = useToast();
  usePageView();

  const defaultFuel = { price: 0, quantity: 0, id: '', name: '' };
  const cash = fuels?.CASH || defaultFuel;
  const nltt = fuels?.NLTT || defaultFuel;
  const pgp = fuels?.PGP || defaultFuel;

  const textMonth = `Tháng ${fuels?.month || ''}`;
  const jsonObject =  {date: `${fuels?.startAt} ${fuels?.endAt}`};

  return (
    <PageSection title="Accountant" rootRef={rootRef}>
      <Grid
        container
        disableEqualOverflow
        spacing={{ xs: 2, lg: 3 }}
      >
        <Grid xs={12}>
          <TitleButton label={t(tokens.nav.overview)} />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewMultis 
            values={[`${cash.price} (đ)`, cash.quantity]}
            title="Nhiên liệu - Hóa đơn"
            imgIcon="/assets/iconly/iconly-glass-chart.svg"
            button={textMonth}
            onClicked={() => {
                gotoListPage(
                  router,
                  paths.fuels.index,
                  {...jsonObject, partner: `[${cash.id}][${cash.name}]`},
                  'date'
                );
              }
            } />
        </Grid>
  
        <Grid xs={12} md={4}>
          <OverviewMultis 
            values={[`${nltt.price} (đ)`, nltt.quantity]}
            title="Nhiên liệu - Nam Long"
            button={textMonth}
            onClicked={() => {
                gotoListPage(
                  router,
                  paths.fuels.index,
                  {...jsonObject, partner: `[${nltt.id}][${nltt.name}]`},
                  'date'
                );
              }
            } />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewMultis 
            values={[`${pgp.price} (đ)`, pgp.quantity]}
            title="Nhiên liệu - Petrolimex"
            imgIcon="/assets/iconly/iconly-glass-info.svg"
            button={textMonth}
            onClicked={() => {
                gotoListPage(
                  router,
                  paths.fuels.index,
                  {...jsonObject, partner: `[${pgp.id}][${pgp.name}]`},
                  'date'
                );
              }
            } />
        </Grid>

        <Grid xs={12} md={4}>
          <OverviewSingle
            value={`${repairs?.totalPrice || '0'} (đ)`}
            title="Bảo dưỡng mới"
            imgIcon="/assets/iconly/iconly-glass-filter.svg"
            button="Chi tiết"
            onClicked={() => {
                if (repairs?.totalPrice) {
                  gotoListPage(
                    router,
                    paths.repairs.index,
                    {fieldName: 0},
                  );
                }else{
                  toastMessage('Chưa có bảo dưỡng mới!');
                }
              }
            } />
        </Grid>
      </Grid>
    </PageSection>
  );
};

export default Page;
